import { useWatch } from 'react-hook-form';

export const useIsBeyondMaxPartySize = () => {
  const partySize = useWatch({
    name: 'partySize'
  });
  return typeof partySize === 'string' && partySize.at(-1) === '+';
};
